import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import SideBar from '../sidebar.js'
import TripDropdown from './TripDorpdown.jsx';
import ListIcon from '@mui/icons-material/List';
import MapIcon from '@mui/icons-material/Map';
import { useNavigate } from 'react-router-dom';


export default function PrimarySearchAppBar({setOpen, trips, tripFilter, setTripFilter, view="map", setView}) {
    const [anchorEl, setAnchorEl] =React.useState(null);
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
    const [sidebarOpen, setSidebarOpen] = React.useState(false)

    const isMenuOpen = Boolean(anchorEl);
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        handleMobileMenuClose();
    };

    const navigate = useNavigate();

    const toggleView = () =>{
        if (view === "map") {
            navigate("/?view=list")
        } else {
            navigate("/?view=map")
        }
    }
    const path = window.location.pathname
    
    const menuId = 'primary-search-account-menu';

    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={menuId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
            <MenuItem onClick={handleMenuClose}>My account</MenuItem>
        </Menu>
    );

    const mobileMenuId = 'primary-search-account-menu-mobile';

    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar position="static">
                <Toolbar>
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        sx={{ mr: 2 }}
                        onClick={()=>{
                            setSidebarOpen(!sidebarOpen)}
                        }
                    >
                        <MenuIcon />
                    </IconButton>
                    <Box sx={{display: 'flex', flexDirection: 'row', flex:1, alignItems:'center', justifyContent: 'center'}}>
                    {(path === '/' || path.includes('/trip')) && (<TripDropdown
                        trips={trips}
                        tripFilter={tripFilter}
                        setTripFilter={setTripFilter}
                    />)}
                    </Box>
                    <Box>
                        {view === "map" ? (<IconButton color="inherit" onClick={toggleView}><ListIcon/></IconButton>) : (<IconButton color="inherit" onClick={toggleView}><MapIcon/></IconButton>)}
                    </Box>
                </Toolbar>
            </AppBar>
            <SideBar open={sidebarOpen} setInfoOpen={setOpen} setOpen={setSidebarOpen}/>
        </Box>
    );
}